import Flickity from 'flickity';
const $ = window.jQuery;

class InlineCarousel {
  constructor() {
    this.instances = [];
    this.elem = $('.inline-carousel__slides');
    this.initialize();
  }

  initialize() {
    if ( ! this.elem.length ) return;

    this.elem.each( (index, elem) => {
      const instance = new Flickity(elem, {
        setGallerySize: true,
        wrapAround: true,
        adaptiveHeight: true,
        lazyLoad: true,
        resize: true,
        imagesLoaded: true,
      });
      this.instances.push(instance);
    });
  }
}

export default InlineCarousel;
